import { stateSchema } from 'src/replicant/State';
import computedProperties from 'src/replicant/config/computedProperties';
import messages from 'src/replicant/config/messages';
import scheduledActions from 'src/replicant/config/scheduledActions';
import ab from 'src/replicant/ruleset/ab';
import asyncGetters from 'src/replicant/config/asyncGetters';
import { createHooks } from '@play-co/components';

const config = {
  computedProperties,
  messages,
  scheduledActions,
  ruleset: { abTests: ab.dynamicAB },
  asyncGetters,
};
export default createHooks(stateSchema, config);
